<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import { useForm } from 'vuestic-ui'
import { newRoute, updateRoute } from '../../core/requests/Routes'
import InputAddress from '../oportunities/components/InputAddress.vue'
import { onlyNumbers, onlyNumbersNoDigits } from '../../core/helpers'
import { ceil } from 'lodash'

const props = defineProps({
  data: {
    default: null,
    type: Object,
  },
})

const vOnlyDigits = onlyNumbers
const vOnlyNumbers = onlyNumbersNoDigits

const emit = defineEmits(['close'])

const isLoading = ref(false)
const fromTolls: any = ref([])
const specialTolls: any = ref([])
const toTolls: any = ref([])
const { isValid, validate, reset } = useForm('formRef')
const form: any = reactive({})
const from: any = ref(null)
const to: any = ref(null)

onMounted(() => {
  if (props.data) {
    form.baseprice = props.data?.baseprice || 0
    form.kilometers = props.data?.kilometers || 0
    form.hours = props.data?.travelhours || 0

    fromTolls.value = props.data.tolls
      .filter((f: any) => f.type == 0)
      .map((f: any) => ({
        q: f.vehicle_type,
        amount: f.amount,
      }))

    specialTolls.value = props.data.tolls
      .filter((f: any) => f.type == 2)
      .map((f: any) => ({
        q: f.vehicle_type,
        amount: f.amount,
      }))

    toTolls.value = props.data.tolls
      .filter((f: any) => f.type == 1)
      .map((f: any) => ({
        q: f.vehicle_type,
        amount: f.amount,
      }))
  }
})

const doProcess = async () => {
  if (validate()) {
    isLoading.value = true
    try {
      //
      if (props.data?.id) {
        await updateRoute(
          {
            kilometers: form.kilometers || 0,
            baseprice: form.baseprice || 0,
            travelhours: form.hours || 0,
            tolls: {
              from: fromTolls.value
                .filter((f: any) => f.amount !== 0)
                .map((f: any) => ({
                  vehicle_type: f.q,
                  amount: f.amount,
                })),
              adtionals: specialTolls.value
                .filter((f: any) => f.amount !== 0)
                .map((f: any) => ({
                  vehicle_type: f.q,
                  amount: f.amount,
                })),
              to: toTolls.value
                .filter((f: any) => f.amount !== 0)
                .map((f: any) => ({
                  vehicle_type: f.q,
                  amount: f.amount,
                })),
            },
          },
          props.data.id,
        )
      } else {
        await newRoute({
          from: from.value.label,
          to: to.value.label,
          kilometers: form.kilometers || 0,
          baseprice: form.baseprice || 0,
          travelhours: form.hours || 0,
          tolls: {
            from: fromTolls.value
              .filter((f: any) => f.amount !== 0)
              .map((f: any) => ({
                vehicle_type: f.q,
                amount: f.amount,
              })),
            adtionals: specialTolls.value
              .filter((f: any) => f.amount !== 0)
              .map((f: any) => ({
                vehicle_type: f.q,
                amount: f.amount,
              })),
            to: toTolls.value
              .filter((f: any) => f.amount !== 0)
              .map((f: any) => ({
                vehicle_type: f.q,
                amount: f.amount,
              })),
          },
        })
      }

      reset()

      emit('close')
    } catch (e: any) {
      console.log(e)
    }

    isLoading.value = false
  }
}

const addNewFrom = () => {
  fromTolls.value.push({
    q: vehicleTypes[0],
    amount: 0,
  })
}

const addNewTo = () => {
  toTolls.value.push({
    q: vehicleTypes[0],
    amount: 0,
  })
}

const addNewSpecial = () => {
  specialTolls.value.push({
    q: aditionals[0],
    amount: 0,
  })
}

const deleteFrom = (index: any) => {
  fromTolls.value.splice(index, 1)
}

const deleteSpecial = (index: any) => {
  specialTolls.value.splice(index, 1)
}

const deleteTo = (index: any) => {
  toTolls.value.splice(index, 1)
}

const vehicleTypes = [
  'Ligero',
  '2 Ejes',
  '3 Ejes',
  '4 Ejes',
  '5 Ejes',
  '6 Ejes',
  '7 Ejes',
  '8 Ejes',
  '9 Ejes',
  '10 Ejes',
  '11 Ejes',
  '12 Ejes',
  '13 Ejes',
  '14 Ejes',
  '15 Ejes',
]

const aditionals = ['Aeropuerto']
</script>

<template>
  <div class="bg-blue-50">
    <div class="mb-4">
      <div class="flex justify-between align-center">
        <h1 v-if="!$props.data?.from" class="h5 font-bold m-0">Nueva Ruta</h1>
        <h1 v-if="$props.data?.from" class="h5 font-bold m-0">Editar Ruta</h1>
      </div>
    </div>

    <div class="new-customer gap-8">
      <VaForm ref="formRef" immediate class="gap-2">
        <div class="w-full bg-white p-2 mt-3 mb-4 py-5">
          <div class="gap-2">
            <p v-if="$props.data" class="text-xs font-bold uppercase">
              {{ $props.data?.from }} / {{ $props.data?.to }}
            </p>
            <div class="bg-white columns-4 py-1 pb-3" :class="$props.data && 'mt-2'">
              <div>
                <InputAddress
                  v-if="!$props.data"
                  label="Origen"
                  :onlyaddress="true"
                  :nomaps="true"
                  @selected="(e) => (from = e)"
                />
              </div>

              <div>
                <InputAddress
                  v-if="!$props.data"
                  label="Destino"
                  :onlyaddress="true"
                  :nomaps="true"
                  @selected="(e) => (to = e)"
                />
              </div>

              <div>
                <VaInput v-model="form.kilometers" v-only-numbers label="Kilometros" type="number" min="0" />
              </div>

              <div>
                <VaInput v-model="form.hours" v-only-numbers label="Horas de Viaje" type="number" min=".5" />
              </div>
            </div>

            <div class="columns-4 mb-4">
              <!-- <div>
                <VaInput
                  v-model="form.baseprice"
                  v-only-digits
                  label="Precio base de Servicio"
                  min="0"
                  @change="
                    () => {
                      form.baseprice = ceil(form.baseprice, 2)
                    }
                  "
                >
                  <template #prependInner>
                    <span class="px-0 -mx-1 font-bold text-sm">S/</span>
                  </template>
                </VaInput>
              </div>

              <div>
                <br />
              </div> -->
            </div>

            <hr />

            <div class="columns-3 mt-4 gap-0">
              <div class="bg-gray-100 py-1">
                <p class="font-bold text-black text-sm text-center">
                  Peajes <span class="uppercase text-xs">(Ida)</span>
                  <VaIcon color="primary" name="add_circle" class="cursor-pointer ml-2" @click="addNewFrom()" />
                </p>
              </div>
              <div class="bg-blue-100 py-1">
                <p class="font-bold text-black text-sm text-center">
                  Peajes <span class="uppercase text-xs">(Vuelta)</span>
                  <VaIcon color="primary" name="add_circle" class="cursor-pointer ml-2" @click="addNewTo()" />
                </p>
              </div>
              <div class="bg-gray-100 py-1">
                <p class="font-bold text-black text-sm text-center">
                  Adicionales
                  <VaIcon color="primary" name="add_circle" class="cursor-pointer ml-2" @click="addNewSpecial()" />
                </p>
              </div>
            </div>
            <!--  -->
            <div class="flex gap-0">
              <div class="flex flex-col w-1/3">
                <div v-for="(item, index) in fromTolls" :key="item" class="bg-gray-100 px-1 pb-1">
                  <div class="flex gap-1 toll">
                    <VaSelect
                      v-model="item.q"
                      class="quantity text-xxs"
                      :options="vehicleTypes"
                      placeholder="Selecciona un tipo"
                      no-options-text="-- No hay items --"
                      background="#fff"
                    />
                    <VaInput
                      v-model="item.amount"
                      v-only-digits
                      type="text"
                      class="amount"
                      background="#fff"
                      @change="
                        () => {
                          item.amount = ceil(item.amount, 2)
                        }
                      "
                    >
                      <template #append>
                        <VaIcon
                          name="delete"
                          class="cursor-pointer ml-1 relative -left-0.5 mr-1"
                          color="danger"
                          @click="deleteFrom(index)"
                        />
                      </template>
                    </VaInput>
                  </div>
                </div>
              </div>
              <div class="flex flex-col w-1/3">
                <div v-for="(item, index) in toTolls" :key="item" class="flex flex-col bg-blue-100 pl-1 pr-3 pb-1">
                  <div class="flex gap-1 toll">
                    <VaSelect
                      v-model="item.q"
                      class="quantity text-xxs"
                      no-options-text="-- No hay items --"
                      :options="vehicleTypes"
                      placeholder="Selecciona un tipo"
                      background="#fff"
                    />

                    <VaInput
                      v-model="item.amount"
                      v-only-digits
                      type="text"
                      class="amount"
                      background="#fff"
                      @change="
                        () => {
                          item.amount = ceil(item.amount, 2)
                        }
                      "
                    >
                      <template #append>
                        <VaIcon
                          name="delete"
                          class="cursor-pointer ml-1 relative -left-0.5 mr-1"
                          color="danger"
                          @click="deleteTo(index)"
                        />
                      </template>
                    </VaInput>
                  </div>
                </div>
              </div>

              <div class="flex flex-col w-1/3">
                <div v-for="(item, index) in specialTolls" :key="item" class="bg-gray-100 px-1 pb-1">
                  <div class="flex gap-1 toll">
                    <VaSelect
                      v-model="item.q"
                      class="quantity text-xxs min-w-[110px]"
                      no-options-text="-- No hay items --"
                      :options="aditionals"
                      placeholder="Selecciona un tipo"
                      background="#fff"
                    />
                    <VaInput
                      v-model="item.amount"
                      v-only-digits
                      type="text"
                      class="amount max-w-[100px]"
                      background="#fff"
                      @change="
                        () => {
                          item.amount = ceil(item.amount, 2)
                        }
                      "
                    >
                      <template #append>
                        <VaIcon
                          name="delete"
                          class="cursor-pointer ml-1 relative -left-0.5 mr-1"
                          color="danger"
                          @click="deleteSpecial(index)"
                        />
                      </template>
                    </VaInput>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VaForm>
    </div>

    <div>
      <div class="flex justify-end">
        <div class="flex gap-2">
          <VaButton
            icon="save"
            color="primary"
            :disabled="!isValid || (!$props.data?.id && (!from?.label || !to?.label))"
            :loading="isLoading"
            @click="doProcess"
          >
            <span class="text-xs px-1">Guardar</span>
          </VaButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.new-customer {
  &-tabs {
    .va-tabs__content {
      width: 100%;
    }
  }

  .float-profile {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.toll {
  .quantity {
    width: 90px;
  }

  .amount {
    width: 110px;
  }
}
</style>
